import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "../pages/Home";
import { Signin } from "../pages/auth/Signin";
import { Signup } from "../pages/auth/Signup";
import { Contact } from "../pages/Contact";
import { AuthProvider } from "../context/AuthContext";

const queryClient = new QueryClient();

export const Routers: any = () => (
  <QueryClientProvider client={queryClient}>
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </AuthProvider>
    </Router>
  </QueryClientProvider>
);
